module.exports = __webpack_public_path__ + "static/media/0047.50ec2b4d.svg";